import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
  AvailabilityResponse,
  AvailabilityState,
} from '../../../types/availabilitySliceInterface';

// Tipos movidos para src/types/availabilitySliceInterface.ts

const initialState: AvailabilityState = {
  data: null,
  loading: false,
  error: null,
};

export const availabilitySlice = createSlice({
  name: 'availability',
  initialState,
  reducers: {
    setAvailability: (state, action: PayloadAction<AvailabilityResponse>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setAvailability } = availabilitySlice.actions;
